import React from 'react';
import { addDays } from 'date-fns';
import { Recipe } from '@/types/recipe';
import { MealPlan } from '@/types/mealPlan';
import { MealCompositionWithRecipes } from '@/types/mealComposition';
import { MealNote } from '@/types/mealNote';
import HomepageTile from '../landing/HomepageTile';

interface OnboardingMealPreviewProps {
  mealPlans: MealPlan[];
  recipes: Recipe[];
  mealCompositions: MealCompositionWithRecipes[];
  mealNotes: MealNote[];
  isLoading: boolean;
}

const OnboardingMealPreview: React.FC<OnboardingMealPreviewProps> = ({ 
  mealPlans, 
  recipes, 
  mealCompositions,
  mealNotes,
  isLoading 
}) => {
  const today = new Date();
  const tomorrow = addDays(today, 1);
  
  // Find the next upcoming meal (today or tomorrow)
  const todayFormatted = today.toISOString().split('T')[0];
  const tomorrowFormatted = tomorrow.toISOString().split('T')[0];
  
  const todayMealPlans = mealPlans.filter(mp => mp.date === todayFormatted);
  const tomorrowMealPlans = mealPlans.filter(mp => mp.date === tomorrowFormatted);
  
  const todayNotes = mealNotes.filter(note => note.date === todayFormatted);
  const tomorrowNotes = mealNotes.filter(note => note.date === tomorrowFormatted);
  
  // Show today's meals if they exist, otherwise show tomorrow's
  const displayDate = todayMealPlans.length > 0 ? today : tomorrow;
  const displayMealPlans = todayMealPlans.length > 0 ? todayMealPlans : tomorrowMealPlans;
  const displayNotes = todayMealPlans.length > 0 ? todayNotes : tomorrowNotes;
  
  // Extract the primary meal type for display in header
  const primaryMealType = displayMealPlans.length > 0 ? displayMealPlans[0].mealType : null;
  
  // If no meals planned for today or tomorrow, don't show anything
  if (!isLoading && displayMealPlans.length === 0) {
    return null;
  }

  return (
    <div className="[&>*]:!py-3 [&>*]:!min-h-0">
      <HomepageTile
        date={displayDate}
        mealPlans={displayMealPlans}
        mealNotes={displayNotes}
        recipes={recipes}
        mealCompositions={mealCompositions}
        primaryMealType={primaryMealType}
      />
    </div>
  );
};

export default OnboardingMealPreview;